import { createAssetSrc } from '@frontend/utils';

export interface SolanaWallet {
  id: string;
  name: string;
  iconSrc: string;
}

export const solanaWallets: SolanaWallet[] = [
  {
    id: 'phantom',
    name: 'Phantom',
    iconSrc: createAssetSrc('phantom', 'wallets'),
  },
  {
    id: 'solflare',
    name: 'Solflare',
    iconSrc: createAssetSrc('solflare', 'wallets'),
  },
  {
    id: 'glow',
    name: 'Glow',
    iconSrc: createAssetSrc('glow', 'wallets'),
  },
  {
    id: 'decaf',
    name: 'Decaf Wallet',
    iconSrc: createAssetSrc('decaf', 'wallets'),
  },
  {
    id: 'espresso-cash',
    name: 'Espresso Cash',
    iconSrc: createAssetSrc('espresso-cash', 'wallets'),
  },
  {
    id: 'ottr',
    name: 'Ottr',
    iconSrc: createAssetSrc('ottr', 'wallets'),
  },
];
